import { useTranslation } from 'react-i18next'
import { Spinner } from './Spinner'

export interface RefreshingIndicatorProps {
  isFetching: boolean
  isLoading: boolean
  // Extra utility classes appended to the Spinner's className.
  className?: string
}

// EP-108 P014 — formalizes rule g (background-refetch spinner) as a reusable
// helper for the ~18 CRUD pages that render this pattern by hand today
// (adoption into call sites is a separate, later rollout — this task only
// adds the primitive). Renders a Spinner sized/styled to match PageHeader's
// isRefreshing indicator exactly (no visual fork). Deliberately NO aria-live
// wrapper: the global staleTime is 1 minute, so periodic background
// refetches would spam screen readers; the Spinner's own role="status" is
// sufficient. Does NOT replace PageHeader's built-in isRefreshing prop.
export function RefreshingIndicator({ isFetching, isLoading, className = '' }: RefreshingIndicatorProps) {
  const { t } = useTranslation('common')

  if (!isFetching || isLoading) return null

  return <Spinner size="sm" className={`text-base-content/60 ${className}`.trim()} aria-label={t('labels.refreshing')} />
}
